import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import OrderTable from './OrderTable';
import type { Transaction } from './types';

const NetsuiteOrders = () => {
  const [soapData, setSoapData] = useState<Transaction[]>([]);
  const [restData, setRestData] = useState<Transaction[]>([]);
  const [soapLoading, setSoapLoading] = useState(true);
  const [restLoading, setRestLoading] = useState(true);
  const [soapError, setSoapError] = useState<string | null>(null);
  const [restError, setRestError] = useState<string | null>(null);

  const fetchSoap = useCallback((bustCache = false) => {
    setSoapLoading(true);
    setSoapError(null);
    const base = Routes.plato_api_soap_netsuite_orders_path();
    const url = bustCache ? `${base}?bust_cache=1` : base;
    axios
      .get<{ data: Transaction[] }>(url)
      .then(res => setSoapData(res.data.data))
      .catch(err => setSoapError(err.message))
      .finally(() => setSoapLoading(false));
  }, []);

  const fetchRest = useCallback((bustCache = false) => {
    setRestLoading(true);
    setRestError(null);
    const base = Routes.plato_api_rest_netsuite_orders_path();
    const url = bustCache ? `${base}?bust_cache=1` : base;
    axios
      .get<{ data: Transaction[] }>(url)
      .then(res => setRestData(res.data.data))
      .catch(err => setRestError(err.message))
      .finally(() => setRestLoading(false));
  }, []);

  useEffect(() => {
    fetchSoap();
    fetchRest();
  }, [fetchSoap, fetchRest]);

  return (
    <div className="tw-p-4">
      <OrderTable
        data={soapData}
        error={soapError}
        loading={soapLoading}
        title="Saved Search 704 (SOAP)"
        onRefresh={() => fetchSoap(true)}
      />
      <OrderTable
        data={restData}
        error={restError}
        loading={restLoading}
        title="SuiteQL (REST)"
        onRefresh={() => fetchRest(true)}
      />
    </div>
  );
};

export default NetsuiteOrders;
